import { Toaster as Sonner, toast } from "sonner";

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "!bg-gradient-to-r !from-[#01ff9a] !to-[#acffe5] !text-[#0f0f0f] !border-none !font-medium",
        },
        style: {
          maxWidth: "calc(100vw - 32px)",
        },
      }}
      style={{
        "--toast-success-bg": "linear-gradient(135deg, #01ff9a, #acffe5)",
        "--toast-success-text": "#0f0f0f",
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
